import { Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'lib-logo',
  imports: [NgOptimizedImage],
  templateUrl: './logo.html',
})
export class Logo {}
